import { create } from "zustand";
import type { SmsConsentData } from "../services/api";

export type SmsConsentSource = "gate" | "preferences";

/**
 * SMS consent the user is answering. Lives outside the inbox provider so the
 * popup comes back after the policy page, which is its own route. Not
 * persisted: a reload drops the question and the switch stays off.
 *
 * `settle` is the operation gate waiting on Accept or Not now. A reload of
 * the text (409) keeps it. `finishWait` releases it.
 */
interface SmsConsentState {
  pending: SmsConsentData | null;
  source: SmsConsentSource | null;
  settle: (() => void) | null;
  setPending: (
    pending: SmsConsentData,
    meta?: { source?: SmsConsentSource; settle?: () => void },
  ) => void;
  finishWait: () => SmsConsentSource | null;
}

export const useSmsConsentStore = create<SmsConsentState>((set, get) => ({
  pending: null,
  source: null,
  settle: null,
  setPending: (pending, meta) =>
    set((state) => ({
      pending,
      source: meta?.source ?? state.source,
      settle: meta?.settle ?? state.settle,
    })),
  finishWait: () => {
    const { settle, source } = get();
    set({ pending: null, source: null, settle: null });
    settle?.();
    return source;
  },
}));
